import { GROUP_SETTINGS_DATA_REQUEST_ASYNC, HANDLE_EDIT_MODE } from '../Table/constants'

import {
  CHANGE_WIZARD_STEP,
  CLOSE_SAVED_MODAL,
  DEFAULT_INFO,
  END_USER_ALERTS_SAVE,
  FETCH_SETTINGS_REQUEST_ASYNC,
  SAVE_INFO_FORM_ASYNC,
  SAVE_SETTINGS_REQUEST_ASYNC,
  TOGGLE_DEFAULT_POLICY_CHECKBOX,
  UPDATE_INFO_FORM,
} from './constants'
import { GROUP_SETTINGS_WIZARD_STEPS } from './wizzard_steps'

export default function () {
  const initialState = {
    data: DEFAULT_INFO,
    endUserAlerts: [],
    infoFormSaved: false,
    loader: false,
    error: null,
    infoFormError: null,
    currentWizardStep: GROUP_SETTINGS_WIZARD_STEPS[0],
    isDefault: false,
    hasExistingDefault: false,
    showSavedModal: false,
    editName: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case GROUP_SETTINGS_DATA_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          infoFormSaved: false,
          data: DEFAULT_INFO,
          currentWizardStep: GROUP_SETTINGS_WIZARD_STEPS[0],
          endUserAlerts: [],
          editName: null,
          error: null,
          infoFormError: null,
        }
      case HANDLE_EDIT_MODE:
        return {
          ...state,
          editName: action.payload.name,
          data: action.payload,
        }
      case END_USER_ALERTS_SAVE:
        return {
          ...state,
          endUserAlerts: [
            ...state.endUserAlerts.filter(
              (e) => e.announcement_id !== action.payload.data.announcement_id
            ),
            action.payload.data,
          ],
        }
      case SAVE_INFO_FORM_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          infoFormSaved: true,
          error: null,
          infoFormError: null,
        }
      case SAVE_INFO_FORM_ASYNC.SUCCESS:
        return {
          ...state,
          data: {
            ...state.data,
            id: action.payload.data?.groupSettingsId || state.data.id,
          },
        }
      case UPDATE_INFO_FORM:
        return {
          ...state,
          data: {
            ...state.data,
            [action.payload.infoType]: action.payload.value,
          },
        }
      case FETCH_SETTINGS_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
          infoFormError: null,
        }
      case FETCH_SETTINGS_REQUEST_ASYNC.SUCCESS: {
        const currentIsDefault = action.payload.data.defaultGroupSettings?.id === state.data.id
        return {
          ...state,
          loader: false,
          hasExistingDefault: action.payload.data.defaultGroupSettings?.id && !currentIsDefault,
          isDefault: currentIsDefault,
        }
      }
      case FETCH_SETTINGS_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          loader: false,
        }
      case SAVE_INFO_FORM_ASYNC.ERROR:
        return {
          ...state,
          infoFormError: action.error,
          loader: false,
          infoFormSaved: false,
        }
      case FETCH_SETTINGS_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case SAVE_SETTINGS_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
        }
      case SAVE_SETTINGS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          showSavedModal: true,
          loader: false,
          editName: null,
        }
      case SAVE_SETTINGS_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case SAVE_SETTINGS_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case CLOSE_SAVED_MODAL:
        return { ...state, showSavedModal: false }
      case TOGGLE_DEFAULT_POLICY_CHECKBOX:
        return {
          ...state,
          isDefault: !state.isDefault,
        }
      case CHANGE_WIZARD_STEP:
        return {
          ...state,
          currentWizardStep: GROUP_SETTINGS_WIZARD_STEPS[action.payload.newStepKey - 1],
        }
      default:
        return state
    }
  }
}
